import React, { Component } from 'react';

export class CompanyType extends Component {
    static displayName = CompanyType.name;

    constructor(props) {
        super(props);
        this.state = { dbcompanyTypes: [], companyTypes: [], loading: true };
    }

    componentDidMount() {
        this.populateWeatherData();
    }

    static renderForecastsTable(data) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr style={{ backgroundColor: "lightgray" }}>
                        <th>Id</th>
                        <th>Name</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(x =>
                        <tr key={x.id}>
                            <td>{x.id}</td>
                            <td>{x.name}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    search(name) {
        if (name !== undefined) {
            let data = this.state.dbcompanyTypes;
            let result = data;

            if (name.trim() !== "") {
                result = data.filter((x) => {
                    return x.name.toLowerCase().indexOf(name.toLowerCase()) >= 0;
                });
            }

            this.setState({ companyTypes: result, dbcompanyTypes: data, loading: false });
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : CompanyType.renderForecastsTable(this.state.companyTypes);

        return (
            <div className="card">
                <div className="card-header py-3">
                    <h5><i className="fa fa-folder-open-o" aria-hidden="true"></i> Metadatas</h5>
                    <div className="form-group has-search" style={{ float: "right", marginTop: "-35px", marginBottom: "-30px" }}>
                        <span className="fa fa-search form-control-feedback"></span>
                        <input onChange={(e) => { this.search(e.target.value) }} type="text" className="form-control" placeholder="Search company types" />
                    </div>
                    <div style={{ clear: "both" }}></div>
                </div>
                <div className="card-body">
                    <div style={{ maxHeight: "365px", overflowY: "auto", paddingRight: "2px" }}>
                        {contents}
                    </div>
                </div>
                <div className="card-footer">
                    Total: {this.state.companyTypes.length}
                </div>
            </div>
        );
    }

    async populateWeatherData() {
        const response = await fetch('/api/companytype');
        const data = await response.json();
        this.setState({ companyTypes: data, dbcompanyTypes: data, loading: false });
    }
}

